import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IPE_UI_LOCALES, normalizeIpeUiLocale } from './locales';
import { setIpeUiLocale } from './storage';
import './ipe-locale-switcher.css';

export default function IpeLocaleSwitcher() {
  const { t, i18n } = useTranslation('common');
  const current = normalizeIpeUiLocale(i18n.resolvedLanguage || i18n.language);
  const currentLabel = IPE_UI_LOCALES.find((item) => item.code === current)?.label || current;
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  return (
    <div className={`ipe-locale-switcher${open ? ' is-open' : ''}`} ref={rootRef}>
      <button
        type="button"
        className="ipe-locale-switcher__btn"
        aria-label={t('language')}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="ipe-locale-switcher__value">{currentLabel}</span>
      </button>
      {open ? (
        <ul className="ipe-locale-switcher__menu" role="listbox" aria-label={t('language')}>
          {IPE_UI_LOCALES.map((item) => {
            const selected = item.code === current;
            return (
              <li key={item.code}>
                <button
                  type="button"
                  role="option"
                  aria-selected={selected}
                  className={selected ? 'is-active' : undefined}
                  onClick={() => {
                    setIpeUiLocale(item.code);
                    setOpen(false);
                  }}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
}

export function IpeLocaleSwitcherFloat() {
  const [docked, setDocked] = useState(false);

  useEffect(() => {
    const sync = () => setDocked(Boolean(document.querySelector('[data-ipe-locale-dock]')));
    sync();
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  if (docked) return null;
  return (
    <div className="ipe-locale-switcher-float">
      <IpeLocaleSwitcher />
    </div>
  );
}
